import React from "react"
import TitleTab from "../../../shared/components/atoms/title-tab/title-tab"
import { withOutScript } from "../../../shared/utils/formatString"
import { datalayerProduct } from "../../../shared/utils/datalayerProducts"
import "./you-can-use.scss"
import { removeDoubleSlash } from "../../../shared/utils/urlUril"

const YouCanUse = props => {
  return (
    <section className="f-you-can-use">
      <TitleTab
        title={
          process.env.LOCALE === "es-PY" ||
          process.env.LOCALE === "es-AR" ||
          process.env.LOCALE === "es-UY"
            ? "También podés usar"
            : "También puedes usar"
        }
        className="f-TitleTab f-TitleTab-pink"
      />
      <div className="f-can-you-use-content">
        {props.products.map((product, index) => product.titulo !== "contenido-oculto" 
          ? (
            <a
                href={removeDoubleSlash(`/productos/${product.referenciaCategoria.slug}/${product.slug}`)
                }
                className="f-product-related"
                key={`product-related-${index}`}
                onClick={() => {
                  datalayerProduct({
                    subCategory: withOutScript(
                      product.referenciaCategoria.slug
                    ),
                    label: product.titulo,
                  })
                }}
              >
                <img
                  className="f-product-related__img"
                  loading="lazy"
                  alt={product.imagenSubcategoria.description}
                  src={product.imagenSubcategoria.file.url}
                />
                <h3 className="f-product-related__title">{product.titulo}</h3>
              </a>
          )
          : null
        )}
      </div>
    </section>
  )
}

export default YouCanUse
